import { useCallback, useRef, useState } from 'react';

import { DriverFormHandler } from '~components/DriverForm/DriverForm';
import { UserFormStateChangeProps } from '~components/UserForm/UserForm';
import { InviteType } from '~components/UserInvite/UserInviteTypeSelector';

export const useDriverForm = () => {
  const driverDialogRef = useRef<DriverFormHandler>(null);
  const [isDriverDialogOpen, setIsDriverDialogOpen] = useState(false);
  const [driverInviteType, setDriverInviteType] = useState<InviteType[]>([]);
  const [driverInviteTypeError, setDriverInviteTypeError] = useState<string>();
  const [driverFormIsDirty, setDriverFormIsDirty] = useState(false);

  const onDriverInviteTypeChange = useCallback((value: InviteType[]) => {
    setDriverInviteType(value);
    setDriverInviteTypeError(undefined);
  }, []);

  const onDriverFormStateChange = ({ isDirty }: UserFormStateChangeProps) => {
    setDriverFormIsDirty(isDirty);
  };

  const createNewDriver = () => {
    setIsDriverDialogOpen(true);
    setDriverInviteType([]);
    setDriverInviteTypeError(undefined);
  };

  return {
    driverDialogRef,
    driverFormIsDirty,
    isDriverDialogOpen,
    setIsDriverDialogOpen,
    driverInviteType,
    setDriverInviteType,
    driverInviteTypeError,
    setDriverInviteTypeError,
    onDriverFormStateChange,
    onDriverInviteTypeChange,
    createNewDriver,
  };
};
